import {useInstantSearch} from "react-instantsearch";

export const useAmountOfHits=()=>{
    const {results: {nbHits}} = useInstantSearch();
    return nbHits;
}